function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009fe3;stroke:#2d2e83;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-7{stroke-miterlimit:10;}.cls-1,.cls-7{stroke-width:2px;}.cls-2{fill:#1d1d1b;}.cls-2,.cls-4,.cls-5,.cls-7{stroke:#1d1d1b;}.cls-3{fill:#36a9e1;}.cls-4{fill:#e30613;}.cls-5{fill:#fff;}.cls-6{fill:#1d71b8;}.cls-7{fill:none;}.cls-8{fill:#be1622;}.cls-9{fill:#e6332a;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1,
  y: 1.25,
  width: 78.85,
  height: 78.85,
  rx: 4.16
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M96.49,127.11c-.41,6-3.08,28.13-6.19,32.4s-9.59-28.4-10.17-34.84c-.65-7.17,4.05-15.4,9-15.31,5.13.1,8.8,6.68,7.33,10.42h-6c-.08-1.94-.39-3-1.2-3-1,0,1.61,1.55,1.61,6.57,0,4.6-2.65,7-1.67,7s1.2-1.36,1.3-3.16Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M97.23,108.8h5.22v8.43h2.2V108.8h5.26v24.61h-5.26V124h-2.2v9.44H97.23Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M117.29,108.8v24.61h-5.22V108.8Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M119.39,108.8h5.22V127h5.49l-.51,6.39h-10.2Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M131.26,108.8h5.22V127H142l-.5,6.39H131.26Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M70.15,154.93,76,142.25H70.57v-5.93h11.2v5.36l-5.28,11.9h5.65l-.51,6H70.15Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M97.51,159.58V136.32h6c1.36,8.34,1.86,11.7,2,12.41h.12c-.14-2.78-.25-7.09-.25-10.34v-2.07h4.82v23.26h-5.77c-1.59-9.67-2-12-2.13-13h-.09c.17,2.91.15,6.78.15,10.57v2.38Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M122.82,150.76h-5.53v2.92h6.26l-.55,5.9H112.31V136.32H123v5.93h-5.75v2.58h5.53Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M140.06,95.87a.21.21,0,0,1,0,.41C124.45,98.06,67.36,106.4,67,133c-.44,29.89,0-33,0-37a.2.2,0,0,1,.2-.2Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M94.84,125.41c-.41,6.06-3,29.52-6.15,33.82s-10.5-31-11.09-37.45c-.65-7.2,4.94-13.08,10-13,5.16.1,9.27,5,7.29,13.27h-6c-.09-2-.45-4.35-1.26-4.35-1,0-1.31.4-1.31,5.45,0,4.62.36,5.58,1.35,5.58s1.15-1.48,1.26-3.28Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M95.66,108.51h5.22V117h2.2v-8.44h5.26v24.62h-5.26v-9.44h-2.2v9.44H95.66Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M115.72,108.51v24.62H110.5V108.51Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M117.82,108.51H123v18.23h5.49l-.51,6.39h-10.2Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M129.69,108.51h5.22v18.23h5.49l-.5,6.39H129.69Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M67.79,154.32l5.82-13.42H68.22v-6.28h11.2v5.67l-5.28,12.59h5.65l-.51,6.35H67.79Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M95.16,159.23V134.62h6c1.37,8.83,1.87,12.38,2,13.13h.13c-.15-2.94-.25-7.49-.25-10.94v-2.19h4.82v24.61H102c-1.59-10.22-2-12.73-2.14-13.7h-.08c.16,3.08.14,7.17.14,11.19v2.51Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M120.47,149.9h-5.53V153h6.26l-.55,6.24H110V134.62h10.73v6.28h-5.75v2.73h5.53Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M70.83,172.81a.19.19,0,0,1,0-.38c15.48-1.76,72.84-10.08,73.23-36.77.44-29.91,0,33.06,0,37a.19.19,0,0,1-.2.18Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 1,
  y: 1,
  width: 78.85,
  height: 78.85,
  rx: 4.16
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M93.94,129.78S89.39,144.39,83,145c0,0,2.56,11.95,5.06,13.95S93.94,129.78,93.94,129.78Z",
  transform: "translate(-64.57 -93.94)"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-9",
  cx: 83,
  cy: 112.76,
  rx: 3.59,
  ry: 1.09,
  transform: "translate(-118.73 -9.34) rotate(-42.04)"
});

function SvgCzlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 80.85 81.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzlogo);
export default __webpack_public_path__ + "static/media/CZLOGO.72f5fcc3.svg";
export { ForwardRef as ReactComponent };